"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4237],{

/***/ 59843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Chip; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 29px;
  height: 30px;
  border-radius: 999px;
  width: fit-content;
  text-align: center;
  background: #f6f6f6;
  vertical-align: middle;
  justify-content: center;
  text-decoration: none;
  outline: 0;
  white-space: nowrap;
  border: none;
  padding: 0 12px;
  cursor: pointer;
`;
const Chip = (_a) => {
  var _b = _a, {
    onClick,
    children
  } = _b, props = __objRest(_b, [
    "onClick",
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    onClick
  }), children);
};




/***/ }),

/***/ 89795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BlockHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28247);
/* harmony import */ var _atoms_Col_Col_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47639);
/* harmony import */ var _atoms_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5529);
/* harmony import */ var _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3685);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49781);








var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  position: relative;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: ${props.hasDivider ? `1px solid ${props.color}` : ""};
`);
const Title = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  color: ${props.color};
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`);
const Decor = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  position: absolute;
  left: 0;
  margin-top: 2px;
  width: 3px;
  height: 21px;
  background-color:  ${props.color};
`);
const ActionLink = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  color: ${props.color} !important;
  --button-icon-color: ${props.color};
  text-decoration: none;
  float: right;
  text-decoration: unset;
  cursor: pointer;
  &:hover {
    ${props.hover === "underline" ? "text-decoration: underline" : `color: ${_configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__/* .theme.brand.primary */ .r.brand.primary} !important`}
  }
`);
const StyledIcon = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l)`
  position: relative;
  top: 2px;
`;
const ActionLinkTitle = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  margin-right: 5px;
`;
const BlockHeader = (_a) => {
  var _b = _a, {
    title,
    actionLink,
    color = "#333",
    hasDivider = false,
    content
  } = _b, props = __objRest(_b, [
    "title",
    "actionLink",
    "color",
    "hasDivider",
    "content"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    hasDivider,
    color
  }, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_Col_Col_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, null, title && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Decor, {
    color
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, {
    color,
    className: "title"
  }, title))), content && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_Col_Col_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
    col: actionLink ? 9.8 : 10.95
  }, content), actionLink && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __spreadValues({}, actionLink.regionName && (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: actionLink.regionName,
    contentName: actionLink.contentName,
    target: actionLink.target
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_6__/* .CustomLink */ .x, {
    targetPath: actionLink.href
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionLink, {
    color: actionLink.color || "#f1f0f1",
    hover: actionLink.hover
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionLinkTitle, null, actionLink.title), !actionLink.hideIcon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    name: "chevron-forward",
    size: 13
  })))));
};




/***/ }),

/***/ 78221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Overlay; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26759);
/* harmony import */ var _hooks_useEventCallback_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15271);




const Overlay = ({
  show,
  children,
  onEscPressed
}) => {
  const elmRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const [, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    const elm = document.createElement("div");
    elm.style.position = "fixed";
    elm.style.top = "0";
    elm.style.left = "0";
    elm.style.right = "0";
    elm.style.bottom = "0";
    elm.style.zIndex = "1070";
    elm.style.display = "flex";
    elm.style.justifyContent = "center";
    elm.style.alignItems = "center";
    elm.style.background = "rgba(0, 0, 0, 0.1)";
    elmRef.current = elm;
    document.body.appendChild(elm);
    setValue((value) => value + 1);
    return () => {
      document.body.removeChild(elm);
    };
  }, [show]);
  const handleDocumentKeyDown = (0,_hooks_useEventCallback_es_js__WEBPACK_IMPORTED_MODULE_2__/* .useEventCallback */ .$)((e) => {
    if (e.keyCode === 27 && onEscPressed) {
      onEscPressed();
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    document.addEventListener("keydown", handleDocumentKeyDown);
    return () => {
      document.removeEventListener("keydown", handleDocumentKeyDown);
    };
  }, [show]);
  if (!show || !elmRef.current) {
    return null;
  }
  return react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, elmRef.current);
};




/***/ }),

/***/ 61175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28247);
/* harmony import */ var _atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5510);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49781);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LEFT_PAGE = "LEFT";
const RIGHT_PAGE = "RIGHT";
const StyledPagination = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul */ .Z.ul`
  margin-top: 0;
  margin-bottom: 0;
  width: fit-content;
  display: flex;
`;
const StyledPaginationBtn = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li */ .Z.li(({ theme, disabled, active }) => `
    pointer-events: ${disabled ? "none" : "auto"};
    display: inline-block;
    ${active && `color: #fff;
      border-color: ${theme.brand.primary};
      &:hover {
        color: ${theme.brand.primary};
      }`}
  `);
const PageLink = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z)(({ theme, active }) => `
  min-width: 36px;
  height: 36px;
  text-align: center;
  box-shadow: none;
  border-color: #ced4da;
  color: ${theme.brand.primary};
  font-size: 12px;
  background-color: #fff;
  padding: 8px;
  margin: 5px;
  &:hover {
    background-color: #f4f4f4;
  }
  ${active && `color: #fff;
    background-color: ${theme.brand.primary};
    border-color: ${theme.brand.primary};
    border-radius: 4px;
    &:hover {
      color: ${theme.brand.primary};
      background-color: ${theme.brand.primary};
      color: #fff;
      border-color: ${theme.brand.primary};
    }
    `}
`);
const DotItem = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li */ .Z.li`
  pointer-events: none;
  display: flex;
  min-width: 36px;
  height: 36px;
  color: ${(props) => props.theme.brand.primary};
  padding: 8px;
  margin: 5px;
  font-size: 12px;
  justify-content: center;
`;
const PaginationButtonWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  z-index: 1;
  display: inline-block;
`;
const range = (from, to, step = 1) => {
  return Array.from(Array(to - from + 1).keys()).map((item) => item * step + from);
};
const Pagination = (_a) => {
  var _b = _a, {
    totalRecords = 0,
    pageLimit = 30,
    pageNeighbours = 2,
    onPageChanged,
    currentPage
  } = _b, props = __objRest(_b, [
    "totalRecords",
    "pageLimit",
    "pageNeighbours",
    "onPageChanged",
    "currentPage"
  ]);
  const totalPages = Math.ceil(totalRecords / pageLimit);
  const gotoPage = (page) => {
    onPageChanged(page);
  };
  const handleClick = (page, e) => {
    e.preventDefault();
    gotoPage(page);
  };
  const handleMoveLeft = (e) => {
    e.preventDefault();
    gotoPage(currentPage - 1);
  };
  const handleMoveRight = (e) => {
    e.preventDefault();
    gotoPage(currentPage + 1);
  };
  const fetchPageNumbers = () => {
    const totalNumbers = pageNeighbours * 2 + 3;
    const totalBlocks = totalNumbers + 2;
    if (totalPages > totalBlocks) {
      let pages2 = [];
      const curr = currentPage > totalPages ? totalPages : currentPage;
      const leftBound = curr - pageNeighbours;
      const rightBound = curr + pageNeighbours;
      const beforeLastPage = totalPages - 1;
      const startPage = leftBound > 2 ? leftBound : 2;
      const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;
      pages2 = range(startPage, endPage);
      const pagesCount = pages2.length;
      const singleSpillOffset = totalNumbers - pagesCount - 1;
      const leftSpill = startPage > 2;
      const rightSpill = endPage < beforeLastPage;
      const leftSpillPage = LEFT_PAGE;
      const rightSpillPage = RIGHT_PAGE;
      if (leftSpill && !rightSpill) {
        const extraPages = range(startPage - singleSpillOffset, startPage - 1);
        pages2 = [leftSpillPage, ...extraPages, ...pages2];
      } else if (!leftSpill && rightSpill) {
        const extraPages = range(endPage + 1, endPage + singleSpillOffset);
        pages2 = [...pages2, ...extraPages, rightSpillPage];
      } else if (leftSpill && rightSpill) {
        pages2 = [leftSpillPage, ...pages2, rightSpillPage];
      }
      return [1, ...pages2, totalPages];
    }
    return range(1, totalPages);
  };
  const pages = fetchPageNumbers();
  return pages.length > 0 ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("nav", __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPagination, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PaginationButtonWrapper, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "paging",
    contentName: "previousPage"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPaginationBtn, {
    disabled: currentPage === 1
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PageLink, {
    onClick: handleMoveLeft,
    "aria-label": "Previous page"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l, {
    name: "chevron-back",
    size: 12
  })))), pages.map((page, index) => {
    if ([LEFT_PAGE, RIGHT_PAGE].includes(page)) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DotItem, {
        key: index
      }, "...");
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PaginationButtonWrapper, __spreadValues({
      key: index
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
      isTrackContent: true,
      regionName: "paging",
      contentName: "gotoPage",
      target: `${page}`
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPaginationBtn, {
      active: currentPage === page
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PageLink, {
      onClick: (e) => handleClick(page, e),
      active: currentPage === page,
      "aria-label": "Next page"
    }, page)));
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PaginationButtonWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPaginationBtn, __spreadValues({
    disabled: currentPage === totalPages
  }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "paging",
    contentName: "nextPage"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PageLink, {
    onClick: handleMoveRight
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l, {
    name: "chevron-forward",
    size: 12
  })))))) : null;
};




/***/ }),

/***/ 46307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Swiper; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18668);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49713);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79215);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9221);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46626);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);
/* harmony import */ var _atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92374);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ theme }) => `.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}
.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}
&:hover {
  .swiper-button-next,
  .swiper-button-prev {
    opacity: 1;
    &.swiper-button-disabled {
      opacity: 0.35;
    }
  }
}
.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-top: -22px;
  background-color: rgba(168, 168, 168, 0.46);
  opacity: 0;
  &.swiper-button-disabled {
    opacity: 0;
    cursor: auto;
    pointer-events: auto;
  }
}
.swiper-pagination {
position: absolute;
text-align: center;
transform: translate3d(0, 0, 0);
z-index: 10;
}
.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #ddd;
}
.swiper-container-horizontal {
z-index: 0;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 4px;
  cursor: pointer;
}
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 10px;
  left: 0;
  width: 100%;
}
.swiper-pagination-bullet-active {
  background: ${theme.brand.secondary};
  width: 24px;
  border-radius: 8px;
}
.swiper-button-next {
  right: 0;
  left: auto;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  &:after {
    mask: url("${_atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__/* .iconMap["chevron-forward"] */ .q["chevron-forward"]}");
    content: ' ';
    height: 30px;
    width: 30px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
}
.swiper-button-prev {
left: 0;
right: auto;
border-top-right-radius: 100px;
border-bottom-right-radius: 100px;
&:after {
  mask: url("${_atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__/* .iconMap["chevron-back"] */ .q["chevron-back"]}");
  content: ' ';
  height: 30px;
  width: 30px;
  mask-size: contain;
  display: inline-block;
  background: #333;
}
}`);
const Swiper = (_a) => {
  var _b = _a, {
    children,
    hasNavigation,
    hasPagination,
    className
  } = _b, props = __objRest(_b, [
    "children",
    "hasNavigation",
    "hasPagination",
    "className"
  ]);
  const swiperProps = Object.assign({}, props);
  if (hasNavigation && !props.navigation) {
    swiperProps.navigation = true;
    swiper_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"].use */ .Z.use([swiper_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z]);
  }
  if (hasPagination && !props.pagination) {
    swiperProps.pagination = true;
    swiper_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"].use */ .Z.use([swiper_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z]);
  }
  const { slidesPerView = "auto" } = swiperProps;
  const renderContent = (e, index, slidesPerView2) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o, {
      style: {
        maxWidth: (slidesPerView2 === "auto" ? 100 : 100 / slidesPerView2) + "%"
      },
      key: index
    }, e);
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(swiper_react__WEBPACK_IMPORTED_MODULE_7__/* .Swiper */ .t, __spreadValues({}, swiperProps), react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, (e, index) => renderContent(e, index, slidesPerView))));
};




/***/ }),

/***/ 51511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nc": function() { return /* binding */ getImageUrlFromGoogleUserContent; },
/* harmony export */   "Nq": function() { return /* binding */ canUseDOM; },
/* harmony export */   "TH": function() { return /* binding */ getMoneyValueUnit; },
/* harmony export */   "np": function() { return /* binding */ getScrollbarWidth; }
/* harmony export */ });
const canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
const getScrollbarWidth = () => {
  let width = 0;
  if (typeof window !== "undefined") {
    if (window.scrollbarWidth && document.body.scrollHeight > window.innerHeight) {
      return window.scrollbarWidth;
    }
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    const inner = document.createElement("div");
    outer.appendChild(inner);
    width = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    window.scrollbarWidth = width;
  }
  return width;
};
const getMoneyValueUnit = (value) => {
  if (value < 1e6)
    return { value: Math.round(value / 1e3 * 1e3) / 1e3, unit: "K" };
  if (value > 1e9)
    return {
      value: Math.round(value / 1e9 * 1e3) / 1e3,
      unit: "t\u1EF7"
    };
  return { value: Math.round(value / 1e6 * 1e3) / 1e3, unit: "tr" };
};
const getImageUrlFromGoogleUserContent = (imageUrl, imageWidth) => {
  let result = imageUrl;
  if (imageUrl.includes("googleusercontent.com")) {
    if (imageWidth) {
      result = `${imageUrl}=w${imageWidth}`;
    }
  }
  return result;
};




/***/ }),

/***/ 15271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useEventCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);


const useEventCallback = (fn, deps) => {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fn);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    ref.current = fn;
  }, [fn, ...deps]);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((...args) => {
    const callback = ref.current;
    callback(...args);
  }, [ref]);
};




/***/ }),

/***/ 40080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72325);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51511);




function useWindowSize() {
  function getSize() {
    if (typeof window !== "undefined")
      return {
        width: window.innerWidth,
        height: window.innerHeight
      };
  }
  const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getSize);
  const updateWindowSize = lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()(setWindowSize, 1e3);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .canUseDOM */ .Nq) {
      return;
    }
    function handleResize() {
      updateWindowSize(getSize());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  if (!_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .canUseDOM */ .Nq) {
    return void 0;
  }
  return windowSize;
}




/***/ })

}]);